/* ==========================================================================
   ROD ARMOUR — Custom JavaScript
   Version: 1.0 | 2026-02-20
   Rules: no edits to theme.js, vendor-scripts-v11.js, or cp-megamenu.js
   ========================================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
     QTY + ATC ROW LAYOUT
     Wraps the quantity block and the adjacent Add to Cart block in a flex row
     so they sit side by side. Works on the legacy Impulse product template.
     -------------------------------------------------------------------------- */

  function initQtyAtcRow() {
    const qtyBlock = document.querySelector('.product__quantity');
    if (!qtyBlock) return;

    // Walk up to the .product-block wrapper
    const qtyProductBlock = qtyBlock.closest('.product-block');
    if (!qtyProductBlock) return;

    // The ATC block is the next .product-block sibling
    const atcProductBlock = qtyProductBlock.nextElementSibling;
    if (!atcProductBlock || !atcProductBlock.querySelector('button[name="add"]')) return;

    // Already wrapped?
    if (qtyProductBlock.parentElement.classList.contains('ra-qty-atc-row')) return;

    // Pull sub-elements that live below the ATC button out of the ATC block
    // so they render below the row, not inside it (avoids inflating row height).
    const belowRowEls = [];
    ['ra-social-proof', 'btn-wrap--size-chart'].forEach(function(cls) {
      const el = atcProductBlock.querySelector('.' + cls);
      if (el) belowRowEls.push(el.parentElement && el.parentElement !== atcProductBlock ? el.parentElement : el);
    });

    // Create wrapper row
    const row = document.createElement('div');
    row.className = 'ra-qty-atc-row';
    const parent = qtyProductBlock.parentElement;

    // Insert row before qtyProductBlock, move both blocks into it
    parent.insertBefore(row, qtyProductBlock);
    row.appendChild(qtyProductBlock);
    row.appendChild(atcProductBlock);

    // Re-insert the below-row elements after the row
    belowRowEls.forEach(function(el) {
      parent.insertBefore(el, row.nextSibling);
    });
  }

  /* --------------------------------------------------------------------------
     COOKIE BANNER COPY + LABEL CLEANUP
     Shopify injects the privacy banner outside normal theme sections. Normalize
     the visible copy and button labels once it appears so mobile can use a
     smaller, cleaner layout without wrapped labels.
     -------------------------------------------------------------------------- */

  function initCookieBanner() {
    function normalizeBanner(banner) {
      if (!banner || banner.dataset.raCookieNormalized === 'true') return false;

      var body = banner.querySelector('.shopify-pc__banner__body');
      var heading = body && body.querySelector('h2');
      var paragraph = body && body.querySelector('p');
      var existingLink = body && body.querySelector('a[href]');
      var policyHref = existingLink ? existingLink.getAttribute('href') : '/pages/privacy-policy';
      var acceptButton = banner.querySelector('.shopify-pc__banner__btn-accept');
      var declineButton = banner.querySelector('.shopify-pc__banner__btn-decline');
      var manageButton = banner.querySelector('.shopify-pc__banner__btn-manage-prefs');

      if (heading) {
        heading.textContent = 'Cookies';
      }

      if (body) {
        if (!paragraph) {
          paragraph = document.createElement('p');
          body.appendChild(paragraph);
        }

        paragraph.innerHTML =
          'Cookies help site performance, analytics, and personalised offers. ' +
          '<a href="' + policyHref + '">Privacy Policy</a>.';
      }

      if (acceptButton) acceptButton.textContent = 'Accept';
      if (declineButton) declineButton.textContent = 'Decline';
      if (manageButton) manageButton.textContent = 'Manage';

      if (acceptButton) acceptButton.setAttribute('data-ra-cookie-role', 'accept');
      if (declineButton) declineButton.setAttribute('data-ra-cookie-role', 'decline');
      if (manageButton) manageButton.setAttribute('data-ra-cookie-role', 'manage');

      banner.dataset.raCookieNormalized = 'true';
      return true;
    }

    function applyBannerCleanup() {
      return normalizeBanner(document.getElementById('shopify-pc__banner'));
    }

    if (applyBannerCleanup()) return;

    var observer = new MutationObserver(function() {
      if (applyBannerCleanup()) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(function() {
      observer.disconnect();
    }, 10000);
  }

  /* --------------------------------------------------------------------------
     PRODUCT ACCORDION POSITION LOCK
     On narrow PDP viewports, opening a tab can shift the viewport downward as
     the collapsible height animates. Preserve the trigger's visual position so
     the content opens in place instead of feeling like it popped above.
     -------------------------------------------------------------------------- */

  function initProductAccordionPositionLock() {
    if (!document.querySelector('.product-single__meta .collapsible-trigger-btn')) return;

    function maintainTriggerPosition(trigger, lockedTop) {
      var startedAt = Date.now();
      var maxDuration = 320;
      var interval = 50;
      var cancelled = false;
      var cleanup = null;

      function cancelLock() {
        cancelled = true;
        if (cleanup) cleanup();
      }

      var cancelEvents = ['wheel', 'touchmove', 'keydown'];
      cleanup = function () {
        cancelEvents.forEach(function (type) {
          window.removeEventListener(type, cancelLock, true);
        });
      };

      cancelEvents.forEach(function (type) {
        window.addEventListener(type, cancelLock, { capture: true, passive: true, once: true });
      });

      function adjustPosition() {
        if (cancelled || !document.body.contains(trigger)) {
          if (cleanup) cleanup();
          return;
        }

        var delta = trigger.getBoundingClientRect().top - lockedTop;
        if (Math.abs(delta) > 2) {
          window.scrollBy(0, delta);
        }

        if (Date.now() - startedAt < maxDuration) {
          window.setTimeout(adjustPosition, interval);
        } else if (cleanup) {
          cleanup();
        }
      }

      window.requestAnimationFrame(adjustPosition);
    }

    document.addEventListener('click', function (event) {
      if (!window.matchMedia('(max-width: 768px)').matches) return;

      var trigger = event.target.closest('.product-single__meta .collapsible-trigger-btn');
      if (!trigger) return;

      var beforeTop = trigger.getBoundingClientRect().top;
      maintainTriggerPosition(trigger, beforeTop);
    }, true);
  }

  /* --------------------------------------------------------------------------
     INIT
     -------------------------------------------------------------------------- */
  function init() {
    initQtyAtcRow();
    initCookieBanner();
    initProductAccordionPositionLock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ==========================================================================
   GA4 add_to_cart tracking — extracted from inline onclick in cp-product-form.liquid
   Uses delegated click so it works with dynamic cart forms and section reloads.
   ========================================================================== */
(function() {
  if (!document.querySelector('[data-ga-add-to-cart]')) return;

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-ga-add-to-cart]');
    if (!btn || typeof dataLayer === 'undefined') return;
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        items: [{
          item_id:       btn.dataset.gaItemId,
          item_name:     btn.dataset.gaItemName,
          item_brand:    btn.dataset.gaItemBrand,
          item_category: btn.dataset.gaItemCategory,
          item_variant:  btn.dataset.gaItemVariant,
          currency:      btn.dataset.gaCurrency,
          price:         parseFloat(btn.dataset.gaPrice)
        }]
      }
    });
  });
})();

/* ==========================================================================
   RA: Prefetch product images on hover for faster product page LCP
   When a user hovers over a product card on collection pages, this prefetches
   the product's featured image so it's already in the browser cache when
   the user navigates to the product page. Uses pointerenter (covers mouse
   and touch) with passive + capture for zero main-thread cost.
   ========================================================================== */
(function() {
  if (!document.querySelector('.grid-product__link, .grid-product__content')) return;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var prefetched = {};
  document.addEventListener('pointerenter', function(e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    var card = e.target.closest('.grid-product__link, .grid-product__content');
    if (!card) return;
    var img = card.querySelector('img[src*="cdn.shopify.com"]');
    if (!img || !img.src || prefetched[img.src]) return;
    prefetched[img.src] = true;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = img.src;
    link.as = 'image';
    document.head.appendChild(link);
  }, {passive: true, capture: true});
})();

/* ==========================================================================
   Lite video facade — loads real player on click (saves ~930KB per YouTube embed)
   ========================================================================== */
(function() {
  if (document.querySelector('.ra-lite-video')) {
    document.addEventListener('click', function(e) {
      var wrapper = e.target.closest('.ra-lite-video');
      if (!wrapper || wrapper.querySelector('iframe')) return;
      var src = wrapper.getAttribute('data-src');
      if (!src) return;
      // Ensure autoplay is in the src
      if (src.indexOf('autoplay=') === -1) src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = wrapper.querySelector('img') ? wrapper.querySelector('img').alt : 'Video';
      wrapper.innerHTML = '';
      wrapper.appendChild(iframe);
    });
  }

  function getYouTubeEmbedSource(src) {
    try {
      var url = new URL(src, window.location.href);
      var host = url.hostname.replace(/^www\./, '');
      var id = '';

      if (host === 'youtu.be') {
        id = url.pathname.split('/').filter(Boolean)[0] || '';
      } else if (host.indexOf('youtube.com') !== -1) {
        if (url.pathname.indexOf('/embed/') === 0) {
          id = url.pathname.split('/embed/')[1].split('/')[0];
        } else {
          id = url.searchParams.get('v') || '';
        }
      }

      if (!id) return '';

      var start = url.searchParams.get('start') || url.searchParams.get('t') || '';
      start = String(start).replace(/s$/, '');

      var embed = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&playsinline=1&rel=0';
      if (/^\d+$/.test(start)) {
        embed += '&start=' + start;
      }

      return embed;
    } catch (error) {
      return '';
    }
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-pdp-video-trigger]');
    if (!trigger) return;

    var container = trigger.closest('.hero__media-container');
    if (container && container.hasAttribute('data-cp-hero-video')) return;
    if (!container) {
      var hero = trigger.closest('.hero');
      container = hero ? hero.querySelector('.hero__media-container') : null;
    }
    var src = trigger.getAttribute('data-video-src');
    if (!container || !src) return;

    event.preventDefault();

    if (container.classList.contains('is-playing')) return;

    var youtubeSource = getYouTubeEmbedSource(src);
    var media;
    var existingVideo = container.querySelector('video.hero__poster-video');

    if (existingVideo && !youtubeSource) {
      media = existingVideo;
      media.classList.add('hero__interactive-video');
      media.controls = true;
      media.autoplay = true;
      media.playsInline = true;
      media.setAttribute('playsinline', '');
      media.setAttribute('controls', '');
    } else if (youtubeSource) {
      media = document.createElement('iframe');
      media.className = 'hero__interactive-video';
      media.src = youtubeSource;
      media.title = trigger.getAttribute('aria-label') || 'Product video';
      media.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      media.setAttribute('allowfullscreen', '');
      media.loading = 'eager';
    } else {
      media = document.createElement('video');
      media.className = 'hero__interactive-video';
      media.controls = true;
      media.autoplay = true;
      media.preload = 'metadata';
      media.playsInline = true;
      media.setAttribute('playsinline', '');
      media.setAttribute('controls', '');
      var poster = trigger.getAttribute('data-video-poster') || '';
      if (poster) {
        media.poster = poster;
        media.setAttribute('poster', poster);
      }
      media.src = src;
    }

    if (!media.parentNode) {
      container.appendChild(media);
    }
    container.classList.add('is-playing');

    if (media.play) {
      media.play().catch(function() {});
    }
  });

  /* --------------------------------------------------------------------------
     SIZE GUIDE LINK
     Open the modal near the buy box first. Fall back to the lower accordion only
     on older product templates that do not render the modal trigger.
     -------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ra-size-guide-jump]');
    if (!trigger) return;
    e.preventDefault();

    var modalTrigger = document.querySelector('[data-sg-open]');
    if (modalTrigger) {
      modalTrigger.click();
      return;
    }

    // Find the Size guide accordion trigger: a collapsible-trigger whose
    // aria-controls ends with '-size'. This is rendered by tab.liquid as
    // Product-content-{id}-size.
    var sizeTrigger = document.querySelector('.collapsible-trigger[aria-controls$="-size"]');
    if (!sizeTrigger) return;

    // Smooth-scroll the trigger into view with some top offset for the sticky header
    sizeTrigger.scrollIntoView({ behavior: 'smooth', block: 'center' });

    // Open the collapsible if it isn't already
    if (sizeTrigger.getAttribute('aria-expanded') !== 'true') {
      // Impulse's collapsible JS listens for click — simulate it so the
      // accordion animation runs through the theme's own handler.
      setTimeout(function () { sizeTrigger.click(); }, 250);
    }
  });

  /* --------------------------------------------------------------------------
     HIDE STANDALONE DELIVERY ACCORDION ON PDPs
     The Description block now renders a nested Delivery tab inside .product-tabs.
     Product templates may still have a standalone Delivery tab block from
     before the restructure. Identify by tab title and hide.
     -------------------------------------------------------------------------- */
  function hideStandaloneDelivery() {
    var hasNested = !!document.querySelector('.product-tabs .collapsible-trigger[aria-controls$="-delivery"]');
    if (!hasNested) return; // only hide standalone if our nested replacement exists
    document.querySelectorAll('.product-section .product-block--tab').forEach(function (block) {
      if (block.querySelector('.product-tabs')) return;
      var trigger = block.querySelector('.collapsible-trigger');
      if (!trigger) return;
      var label = (trigger.textContent || '').trim().toLowerCase();
      if (label === 'delivery') block.style.display = 'none';
    });
  }
  // Run at multiple phases to handle Impulse's deferred section mount
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideStandaloneDelivery);
  }
  hideStandaloneDelivery();
  setTimeout(hideStandaloneDelivery, 500);
  setTimeout(hideStandaloneDelivery, 1500);
  window.addEventListener('load', hideStandaloneDelivery);

  /* --------------------------------------------------------------------------
     PDP MOBILE IMAGE — force Flickity to recompute cell widths
     ra.css now sets .product-main-slide to a large partial width on <=768px
     so the next image peeks in. Flickity caches cell sizes at init time, so we
     poke it to resize() after layout settles and on viewport changes.
     -------------------------------------------------------------------------- */
  function resizeProductSlideshow() {
    if (window.innerWidth > 768) return;
    const slider = document.querySelector('.product-slideshow.flickity-enabled');
    if (!slider || !window.Flickity) return;
    const flickity = window.Flickity.data(slider);
    if (flickity && typeof flickity.resize === 'function') {
      flickity.resize();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resizeProductSlideshow);
  }
  setTimeout(resizeProductSlideshow, 300);
  setTimeout(resizeProductSlideshow, 1200);
  window.addEventListener('load', resizeProductSlideshow);
  window.addEventListener('resize', resizeProductSlideshow, { passive: true });
})();

/* ==========================================================================
   RA: Add-to-Cart success animation
   Pulses the header cart dot on ATC. Two triggers:
     1. Form submit on .product-form / sticky ATC click  → immediate feedback
     2. MutationObserver on .cart-link__bubble class     → catches Rebuy /
        AJAX adds that bypass the form submit
   ========================================================================== */
(function () {
  var cartLink = document.querySelector('.site-nav__link[data-ra-rebuy-cart-trigger] .cart-link');
  if (!cartLink) return;
  var bubble = document.querySelector('.cart-link__bubble');

  function syncHasItems() {
    if (!bubble) return;
    cartLink.classList.toggle('cart-link--has-items', bubble.classList.contains('cart-link__bubble--visible'));
  }

  function pulse() {
    cartLink.classList.remove('cart-link--pulse');
    void cartLink.offsetWidth;
    cartLink.classList.add('cart-link--pulse');
    setTimeout(function () { cartLink.classList.remove('cart-link--pulse'); }, 850);
  }

  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-sticky-add-to-cart], button[name="add"], .product-form__cart-submit, [data-add-to-cart]');
    if (!atc) return;
    if (atc.disabled || atc.getAttribute('aria-disabled') === 'true') return;
    setTimeout(pulse, 120);
  }, { passive: true });

  if (bubble && 'MutationObserver' in window) {
    var lastVisible = bubble.classList.contains('cart-link__bubble--visible');
    syncHasItems();
    new MutationObserver(function () {
      var nowVisible = bubble.classList.contains('cart-link__bubble--visible');
      syncHasItems();
      if (nowVisible && !lastVisible) pulse();
      lastVisible = nowVisible;
    }).observe(bubble, { attributes: true, attributeFilter: ['class'] });
  } else {
    syncHasItems();
  }
})();

/* ==========================================================================
   RA: Back-in-stock signup toggle
   Shows the BIS form when the current variant is sold out, hides it
   otherwise. Uses Shopify's variantChange detail instead of the ATC
   button disabled state because the button is also disabled while AJAX
   add-to-cart is loading.

   Also detects ?contact_posted=true (Shopify's post-/contact redirect)
   and renders a success banner so visitors get confirmation that their
   notify-request landed.
   ========================================================================== */
(function () {
  var atc = document.querySelector('button[name="add"][data-add-to-cart]');
  var wrap = document.querySelector('[data-ra-bis-wrap]');
  if (!atc || !wrap) return;

  var variantSelect = document.querySelector('[data-product-select], select[name="id"]');

  function setActive(active) {
    wrap.classList.toggle('ra-bis--active', !!active);
    wrap.setAttribute('aria-hidden', active ? 'false' : 'true');
  }

  function updateRequestFields(label, variantId) {
    var body = wrap.querySelector('[data-ra-bis-body]');
    var vEl   = wrap.querySelector('[data-ra-bis-variant]');
    var vIdEl = wrap.querySelector('[data-ra-bis-variant-id]');
    if (vEl)   vEl.value = label || '';
    if (vIdEl && variantId) vIdEl.value = variantId;
    if (body) {
      var product = (wrap.querySelector('[data-ra-bis-product]') || {}).value || '';
      body.value = 'Please notify me when ' + product +
                   (label && label !== 'Default Title' ? ' (' + label + ')' : '') +
                   ' is back in stock.';
    }
  }

  function selectedOptionSoldOut() {
    if (!variantSelect) return null;
    var selected = variantSelect.options[variantSelect.selectedIndex];
    if (!selected) return null;
    return selected.disabled ||
      selected.hasAttribute('disabled') ||
      /sold out/i.test(selected.textContent || '');
  }

  function labelFromSelectedOption() {
    if (!variantSelect) return '';
    var selected = variantSelect.options[variantSelect.selectedIndex];
    if (!selected) return '';
    // Variant title may legitimately contain ' - ' (e.g. "Pro - Black").
    // Split on the LAST occurrence so only the trailing price/status suffix is dropped.
    var raw = (selected.textContent || '').trim();
    var lastSep = raw.lastIndexOf(' - ');
    return lastSep > -1 ? raw.slice(0, lastSep).trim() : raw;
  }

  function syncFromSelectedOption() {
    var soldOut = selectedOptionSoldOut();
    if (soldOut === null) return;
    updateRequestFields(labelFromSelectedOption(), variantSelect && variantSelect.value);
    setActive(soldOut);
  }

  function syncFromVariant(variant) {
    if (!variant) {
      setActive(false);
      return;
    }
    updateRequestFields(variant.title, variant.id);
    setActive(variant.available === false);
  }

  document.addEventListener('variant:change', function (evt) {
    syncFromVariant(evt.detail && evt.detail.variant);
  });

  if (variantSelect) {
    variantSelect.addEventListener('change', syncFromSelectedOption);
    syncFromSelectedOption();
  }

  // Pre-submit, drop a sessionStorage flag so we only show the BIS success
  // banner if the redirect came from THIS form (not the generic contact form
  // on /pages/contact, which would otherwise false-positive the banner on
  // PDP visits that happen after a contact-page submit).
  var bisForm = wrap.querySelector('[data-ra-bis-form]');
  if (bisForm) {
    bisForm.addEventListener('submit', function () {
      try { sessionStorage.setItem('ra_bis_pending', '1'); } catch (e) {}
    });
  }

  if (/contact_posted=true/.test(window.location.search) && wrap) {
    var pending = false;
    try { pending = sessionStorage.getItem('ra_bis_pending') === '1'; } catch (e) {}
    if (pending) {
      try { sessionStorage.removeItem('ra_bis_pending'); } catch (e) {}
      var form = wrap.querySelector('[data-ra-bis-form]');
      if (form) {
        var ok = document.createElement('div');
        ok.className = 'ra-bis__success';
        ok.textContent = form.getAttribute('data-ra-bis-success') || "Thanks for contacting us. We'll get back to you as soon as possible.";
        form.appendChild(ok);
        wrap.classList.add('ra-bis--success', 'ra-bis--active');
        try {
          var clean = window.location.pathname + window.location.hash;
          window.history.replaceState({}, '', clean);
        } catch (e) {}
      }
    }
  }
})();
